import React from 'react';

import { Chip, Typography } from '@material-ui/core';

import classes from '../../css/getCSS';
import * as constants from '../../config/constants';


const activeFilters = (props) => {
  const filters = props.activeFilters.map((item) => {
    let ondelete = () => props.handleRemoveFilter(item.id, props.activeFilters);
    if (item.preselected) { ondelete = null; }
    return (
      <Chip
        key={item.id}
        variant="outlined"
        color="default"
        label={`${constants.SEARCH_FILTERS[item.name]}: ${item.display_value}`}
        onDelete={ondelete}
        onClick={() => props.handleRemoveFilter(item.id, props.activeFilters)}
        className={classes.activeFilterChip}
      />
    );
  });
  return (
    <React.Fragment>
      <Typography>
        Some filters may be pre-selected depending on the site you are viewing.
      </Typography>
      <div className={classes.activeFiltersWrapper}>
        {filters}
      </div>
    </React.Fragment>
  );
};

export default activeFilters;



// WEBPACK FOOTER //
// ./src/search/components/ActiveFilters.js